import React, { createContext, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';

// Tworzymy kontekst
const ResponsiveContext = createContext();

// Hook do łatwego dostępu do kontekstu
export const useResponsive = () => useContext(ResponsiveContext);

export function ResponsiveProvider({ children }) {
    const isMobile = useMediaQuery({ query: '(max-width: 719px)' });
    const isTablet = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1024px)' });
    const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });

    const value = {
        isMobile,
        isTablet,
        isDesktop,
    };

    return (
        <ResponsiveContext.Provider value={value}>
            {children}
        </ResponsiveContext.Provider>
    );
};


